/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import style from "./workingFile.module.scss";
import Header from "./Header";
import Footer from "./Footer";
import InvoiceDetails from "./InvoiceDetails";
import Main from "./main";
import BankDetails from "./BankDetails";
import { GetEmployerDetailsByid } from "../../apiServices";
import sealImage from "../../assets/images/signseal.png";
import ITMain from "./ItMain";

const Content = [
  {
    description: "P SELVABHARATHI | 3775 | Valve CNC Operator",
    amount: "₹19,285.00",
    joiningDate: "23rd July 2024",
  },
  {
    description: "P SELVABHARATHI | 3775 | Valve CNC Operator",
    amount: "₹19,285.00",
    joiningDate: "23rd July 2024",
  },
];

const Document = forwardRef(
  ({ data, empId, invoicecategory, invoiceNumber }, ref) => {
    const [employerDetails, setEmployerDetails] = useState("");
    const [showbankDetails, setBankDetails] = useState(false);
    const [pages, setPages] = useState([]); // State to store pages

    const pdfRefs = useRef([]);
    // const items = data.candidates;

    const items = useMemo(
      () => data.candidates.filter((candidate) => candidate.checked),
      [data]
    );
    console.log(items, "kkk");

    const firstPageItems = 6; // Number of items for the first page
    const subsequentPageItems = 10; // Number of items for subsequent pages

    useEffect(() => {
      GetEmployerDetailsByid(empId).then((data) => {
        setEmployerDetails(data.employer);
      });
    }, [empId]);

    useImperativeHandle(ref, () => ({
      generatePDF,
    }));

    useEffect(() => {
      const calculatedPages = calculatePages();
      setPages(calculatedPages); // Update the pages state
    }, [items, firstPageItems, subsequentPageItems, showbankDetails]);

    const calculatePages = () => {
      const totalItems = items.length;
      let pages = [];
      if (totalItems <= 1) {
        pages.push(items);
        if (!showbankDetails) setBankDetails(false);
      } else if (totalItems <= firstPageItems) {
        pages.push(items);
        if (!showbankDetails) setBankDetails(true);
      } else {
        pages.push(items.slice(0, firstPageItems));

        const remainingItems = items.slice(firstPageItems);
        if (remainingItems.length <= 3) {
          pages.push(remainingItems);
          if (showbankDetails) setBankDetails(false);
        } else {
          for (let i = 0; i < remainingItems.length; i += subsequentPageItems) {
            pages.push(remainingItems.slice(i, i + subsequentPageItems));
          }
          if (!showbankDetails) setBankDetails(true);
        }
      }

      if (showbankDetails && !pages.includes("BANK_DETAILS")) {
        pages.push("BANK_DETAILS");
      }

      return pages;
    };

    const generatePDF = async () => {
      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      for (let index = 0; index < pdfRefs.current.length; index++) {
        const container = pdfRefs.current[index];
        if (!container) continue;

        const canvas = await html2canvas(container, { scale: 2 });
        const imageData = canvas.toDataURL("image/jpeg", 0.7);

        if (index > 0) {
          doc.addPage();
        }
        doc.addImage(
          imageData,
          "JPEG",
          0,
          0,
          pageWidth,
          pageHeight,
          undefined,
          "FAST"
        );
      }

      doc.save(`Invoice_${invoiceNumber}.pdf`);
    };

    return (
      <div>
        {pages.map((page, index) => (
          <div
            key={index}
            ref={(el) => (pdfRefs.current[index] = el)}
            className={`${style.A4}`}
          >
            <div className="header">
              <Header />
            </div>

            {index === 0 && page !== "BANK_DETAILS" && (
              <div
                className="subHeader"
                style={{ marginTop: "50px", marginBottom: "10px" }}
              >
                <InvoiceDetails
                  employerDetails={employerDetails}
                  invoicedata={data}
                  invoiceNumber={invoiceNumber}
                />
              </div>
            )}

            {invoicecategory != "IT Service" ? (
              <div className="main">
                {Array.isArray(page) ? (
                  <>
                    <Main Content={page} />
                    {!showbankDetails && index != 0 && (
                      <div
                        className={`main mt-4 ms-1 me-1 ${style.BankDetailsContainer}`}
                      >
                        <div>
                          <div className="row">
                            <div
                              className="col-sm-6"
                              style={{ fontSize: "12.5px" }}
                            >
                              <div>&nbsp; Bank Details</div>
                              <div className="mt-2"></div>
                              <div>
                                &nbsp; Account Name: TAIZO TECHNOLOGIES PRIVATE
                                LIMITED
                              </div>
                              <div>&nbsp; Account No: 50200044772250</div>
                              <div>&nbsp; IFSC Code: HDFC0000141</div>
                              <div>&nbsp; SWIFT Code: HDFCINBB</div>
                              <div>&nbsp; Account Branch: R.A PURAM</div>
                              <div>
                                &nbsp; Address: NO.10, Third Cross Street,
                                <div>
                                  &nbsp; R.A. Puram, Chennai, Tamil Nadu -
                                  600028
                                </div>
                              </div>
                              <div className="d-flex justify-content-end mt-3">
                                <img src={sealImage} alt="" width={160} />
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <BankDetails amountData={data} />
                            </div>
                          </div>
                        </div>
                        <div style={{ marginTop: "5%" }}>
                          <div
                            className="row d-flex align-items-end"
                            style={{ fontSize: "13px" }}
                          >
                            <div className="col-sm-4">
                              Questions?
                              <div className="d-flex justify-content-between">
                                <div>
                                  <div>Email Us at</div>
                                  <div> or Call Us at</div>
                                </div>
                                <div>
                                  <div>
                                    <b>info@taizo.in</b>
                                  </div>
                                  <div>
                                    <b>+91 780 680 5808</b>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-8 d-flex justify-content-end">
                              <div className={`${style.ThankYou}`}>
                                Thank You!
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {!showbankDetails && pages.length <= 1 && (
                      <div
                        className={`main mt-4 ms-1 me-1 ${style.BankDetailsContainer}`}
                      >
                        <div>
                          <div className="row">
                            <div
                              className="col-sm-6"
                              style={{ fontSize: "12.5px" }}
                            >
                              <div>&nbsp; Bank Details</div>
                              <div className="mt-2"></div>
                              <div>
                                &nbsp; Account Name: TAIZO TECHNOLOGIES PRIVATE
                                LIMITED
                              </div>
                              <div>&nbsp; Account No: 50200044772250</div>
                              <div>&nbsp; IFSC Code: HDFC0000141</div>
                              <div>&nbsp; SWIFT Code: HDFCINBB</div>
                              <div>&nbsp; Account Branch: R.A PURAM</div>
                              <div>
                                &nbsp; Address: NO.10, Third Cross Street,
                                <div>
                                  &nbsp; R.A. Puram, Chennai, Tamil Nadu -
                                  600028
                                </div>
                              </div>
                              <div className="d-flex justify-content-end mt-3">
                                <img src={sealImage} alt="" width={160} />
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <BankDetails amountData={data} />
                            </div>
                          </div>
                        </div>
                        <div style={{ marginTop: "5%" }}>
                          <div
                            className="row d-flex align-items-end"
                            style={{ fontSize: "13px" }}
                          >
                            <div className="col-sm-4">
                              Questions?
                              <div className="d-flex justify-content-between">
                                <div>
                                  <div>Email Us at</div>
                                  <div> or Call Us at</div>
                                </div>
                                <div>
                                  <div>
                                    <b>info@taizo.in</b>
                                  </div>
                                  <div>
                                    <b>+91 780 680 5808</b>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-8 d-flex justify-content-end">
                              <div className={`${style.ThankYou}`}>
                                Thank You!
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : showbankDetails && page === "BANK_DETAILS" ? (
                  <div
                    className={`main mt-4 ms-1 me-1 ${style.BankDetailsContainer}`}
                  >
                    <div>
                      <div className="row">
                        <div
                          className="col-sm-6"
                          style={{ fontSize: "12.5px" }}
                        >
                          <div>&nbsp; Bank Details</div>
                          <div className="mt-2"></div>
                          <div>
                            &nbsp; Account Name: TAIZO TECHNOLOGIES PRIVATE
                            LIMITED
                          </div>
                          <div>&nbsp; Account No: 50200044772250</div>
                          <div>&nbsp; IFSC Code: HDFC0000141</div>
                          <div>&nbsp; SWIFT Code: HDFCINBB</div>
                          <div>&nbsp; Account Branch: R.A PURAM</div>
                          <div>
                            &nbsp; Address: NO.10, Third Cross Street,
                            <div>
                              &nbsp; R.A. Puram, Chennai, Tamil Nadu - 600028
                            </div>
                          </div>
                          <div className="d-flex justify-content-end mt-3">
                            <img src={sealImage} alt="" width={160} />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <BankDetails amountData={data} />
                        </div>
                      </div>
                    </div>
                    <div style={{ marginTop: "5%" }}>
                      <div
                        className="row d-flex align-items-end"
                        style={{ fontSize: "13px" }}
                      >
                        <div className="col-sm-4">
                          Questions?
                          <div className="d-flex justify-content-between">
                            <div>
                              <div>Email Us at</div>
                              <div> or Call Us at</div>
                            </div>
                            <div>
                              <div>
                                <b>info@taizo.in</b>
                              </div>
                              <div>
                                <b>+91 780 680 5808</b>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-8 d-flex justify-content-end">
                          <div className={`${style.ThankYou}`}>Thank You!</div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : (
              <>
                <ITMain />
                <div
                  className={`main mt-4 ms-1 me-1 ${style.BankDetailsContainer}`}
                >
                  <div>
                    <div className="row">
                      <div className="col-sm-6" style={{ fontSize: "12.5px" }}>
                        <div>&nbsp; Bank Details</div>
                        <div className="mt-2"></div>
                        <div>
                          &nbsp; Account Name: TAIZO TECHNOLOGIES PRIVATE
                          LIMITED
                        </div>
                        <div>&nbsp; Account No: 50200044772250</div>
                        <div>&nbsp; IFSC Code: HDFC0000141</div>
                        <div>&nbsp; SWIFT Code: HDFCINBB</div>
                        <div>&nbsp; Account Branch: R.A PURAM</div>
                        <div>
                          &nbsp; Address: NO.10, Third Cross Street,
                          <div>
                            &nbsp; R.A. Puram, Chennai, Tamil Nadu - 600028
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                          <img src={sealImage} alt="" width={160} />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <BankDetails amountData={data} />
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: "5%" }}>
                    <div
                      className="row d-flex align-items-end"
                      style={{ fontSize: "13px" }}
                    >
                      <div className="col-sm-4">
                        Questions?
                        <div className="d-flex justify-content-between">
                          <div>
                            <div>Email Us at</div>
                            <div> or Call Us at</div>
                          </div>
                          <div>
                            <div>
                              <b>info@taizo.in</b>
                            </div>
                            <div>
                              <b>+91 780 680 5808</b>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-8 d-flex justify-content-end">
                        <div className={`${style.ThankYou}`}>Thank You!</div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="footer">
              <Footer />
            </div>
          </div>
        ))}
      </div>
    );
  }
);

export default Document;
